import _ from 'underscore';

class Tarot {
    constructor(options) {
        var defaults = {
            selector: '#app-astrology-tarot'
        };
        this.params = Object.assign({}, defaults, options || {});
        this.el = document.querySelector(this.params.selector);
        this.start();
    }

    start() {

        /* Data */
        var headlines = ['Παρελθόν', 'Παρόν', 'Μέλλον', 'Απάντηση'];
        var tarotCards = this.params.cards;
        var activeCards;
        var tarotCardIndex;

        /* Containers */
        var tarotApplication = this.el.querySelector('[data-role="tarot-application"]');
        var tarotResultsCardsContainer;
        var tarotResultsTextsContainer;

        /* Templates */
        var tarotFormTemplate = _.template(this.el.querySelector('[data-role="tarot-form-template"]').innerHTML);
        var tarotCardsTemplate = _.template(this.el.querySelector('[data-role="tarot-cards-template"]').innerHTML);
        var tarotCardTemplate = _.template(this.el.querySelector('[data-role="tarot-card-template"]').innerHTML);
        var tarotTextTemplate = _.template(this.el.querySelector('[data-role="tarot-text-template"]').innerHTML);


        /* Start application */
        tarotApplication.innerHTML = tarotFormTemplate();


        /* Form submit event */
        tarotApplication.addEventListener('submit', (event) => {
            if (event.target.tagName === 'FORM') {
                event.preventDefault();
                var question = tarotApplication.querySelector('input[name="question"]').value;
                var categoryId = tarotApplication.querySelector('select[name="category"]').value;
                activeCards = _.where(tarotCards, {
                    catid: categoryId
                });
                tarotApplication.innerHTML = '';
                tarotApplication.innerHTML = tarotCardsTemplate({
                    question: question,
                    cards: activeCards
                });
                tarotResultsCardsContainer = tarotApplication.querySelector('[data-role="tarot-results-cards"]');
                tarotResultsTextsContainer = tarotApplication.querySelector('[data-role="tarot-results-texts"]');
                tarotCardIndex = 1;
            }
        });

        /* Card select event */
        tarotApplication.addEventListener('click', (event) => {

            if (event.target.dataset && event.target.dataset.role === 'tarot-card') {
                event.preventDefault();
                if (tarotCardIndex < 5) {
                    var random = _.random(0, (activeCards.length - 1));
                    var card = activeCards[random];
                    var headline = headlines[tarotCardIndex - 1];
                    var text = card['desc_' + tarotCardIndex];
                    tarotResultsCardsContainer.innerHTML += tarotCardTemplate({
                        image: card.image,
                        title: card.title
                    });
                    tarotResultsTextsContainer.innerHTML += tarotTextTemplate({
                        title: card.title,
                        text: text,
                        headline: headline
                    });
                    tarotCardIndex++;
                    activeCards = _.without(activeCards, _.findWhere(activeCards, {
                        id: card.id
                    }));
                    event.target.remove();

                    if (tarotCardIndex === 5) {
                        tarotApplication.querySelector('[data-role="tarot-cards"]').classList.add('disabled');
                        tarotApplication.querySelector('[data-action="tarot-restart"]').style.display = 'inline';
                    }
                }
            }
        });

        /* Restart event */
        /*
        tarotApplication.addEventListener('click', (event) => {
            if (event.target.dataset && event.target.dataset.action === 'tarot-restart') {
                event.preventDefault();
                tarotApplication.innerHTML = tarotFormTemplate();
            }
        });
        */

    }

}

export {
    Tarot as
        default
};
